module.exports = __webpack_public_path__ + "static/media/Retina_factsheet.cf940a60.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/download/files/Retina_factsheet.pdf
// module id = 790
// module chunks = 0